import { Http, Headers } from '@angular/http';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';
import {ConfigProvider} from "../config/config";

/*
  Generated class for the RequestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RequestProvider {


  constructor(
    public http: Http,
    private configProvider: ConfigProvider
  ) {
  }

  getHeaders() {
    let headers = new Headers();
    headers.append('Content-Type', 'text/plain');

    return headers;
  }

  getOptions() {
    return { headers: this.getHeaders() };
  }

  getUrl(url, accessToken = true) {
    let token = localStorage.getItem("token");
    let accessTokenParam = (accessToken) ? `?token=${token}` : '';

    return this.configProvider.serverAddress + url + accessTokenParam;
  }

  post(url, data, accessToken = true) {
    return this.http.post(this.getUrl(url, accessToken), data, this.getOptions()).map(res => res.json());
  }

  get(url, accessToken = true) {
    return this.http.get(this.getUrl(url, accessToken), this.getOptions()).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/providers/request/request.ts